export default process.env.REACT_APP_SERVICE_ENDPOINT || "api";
